"use strict";
/**
 * @module Services.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var permission_1 = require("./../../features/security/permission");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var list_global_permissions_result_1 = require("./../../services/security/list-global-permissions-result");
var security_1 = require("../../../features/security");
/**
 * Serialiser for {@link ListGlobalPermissionsResult}
 */
var ListGlobalPermissionsResultSerialiserClass = /** @class */ (function (_super) {
    __extends(ListGlobalPermissionsResultSerialiserClass, _super);
    function ListGlobalPermissionsResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListGlobalPermissionsResultSerialiserClass.prototype.read = function (bis) {
        return new list_global_permissions_result_1.ListGlobalPermissionsResult(Codec.readCollection(bis, function () {
            var k = permission_1.GlobalPermissionCode[bis.read()];
            return security_1.GlobalPermission[k];
        }));
    };
    return ListGlobalPermissionsResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ListGlobalPermissionsResultSerialiserClass = ListGlobalPermissionsResultSerialiserClass;
/**
 * The {@link ListGlobalPermissionsResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ListGlobalPermissionsResultSerialiser = new ListGlobalPermissionsResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/list-global-permissions-result-serialiser.js
// module id = 1368
// module chunks = 1